var exports = {
  "k": "x127c5a35--802277--container",
  "l": "x127c5a35--802277--phone",
};

module.exports = exports;
